class RecentlyViewed extends HTMLElement{
    constructor(){
        super();

        this.container = this.querySelector('.recently__view-container');
        this.maxItem = this.dataset.maxItem;

        this.getRecentlyViewedProducts();
    }

    async getRecentlyViewedProducts() {
        let handleList = [];
        const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
                
        if (productData == null) return false;

        const firstProduct = productData[0];
        const collectionHandle = firstProduct.tag;
        productData.map(product => {handleList.unshift(`${ product.handle}_`)});
        handleList = handleList.slice(0, this.maxItem).join("");
        const url = `/search?view=recently-view&q=${handleList}${collectionHandle}`;

        const parser = new DOMParser();
        const response = await fetch(url);
        
        if (!response.ok) {
            var error = new Error(response.status);
            console.warn('Something went wrong.', error.message);
            throw error;
        }
        
        const responseText = await response.text();
        const responseHTML = parser.parseFromString(responseText, "text/html").querySelector('#container').innerHTML;
        this.container.closest('section').style.display = "block";
        this.container.innerHTML = responseHTML;

        this.initSlider();
    }

    initSlider() {
        new Swiper('recently-viewed', {
            direction: 'horizontal',
            loop: false,
            mousewheel: {
                forceToAxis: true,
            },
            slidesPerView: 1.5,
            spaceBetween: 20,
            breakpoints: {
                480: {
                    slidesPerView: 2.5
                },
                750: {
                    slidesPerView: 3
                },
                990: {
                    slidesPerView: 4
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    }
}

customElements.define('recently-viewed', RecentlyViewed);
                        
                        